import React from "react";
import PdfViewer from "../../PdfViewer";

const ProcesosPOCRACI = () => {
  const pdfUrl = `${process.env.REACT_APP_BUCKET}/pdf/proceso-POC-RACI.pdf`;
  /*const pdfUrl = "/pdf/proceso-POC-RACI.pdf";*/

  console.log("PDF URL:", pdfUrl);

  return (
    <>
      <main>
        <div class="titulo">
          <h1>Proceso Comercial Completo - Diagrama</h1>
        </div>
        <div class="sub-titulo">
          <h2>Descripción detallada del procedimiento</h2>
        </div>
        <div className="pdf-container">
          <PdfViewer pdfUrl={pdfUrl} />
        </div>
      </main>
    </>
  );
};

 export default ProcesosPOCRACI;
